import { useEffect } from 'react'
import SiteNav from '../components/SiteNav'
import ShopHero from './shop/ShopHero'
import { ShopCommunity, ShopHowItWorks, ShopTestimonials } from './shop/ShopStory'
import ShopMerch from './shop/ShopMerch'
import { ShopTogether, ShopFinalCTA } from './shop/ShopEngage'
import ShopFooter from './shop/ShopFooter'

// Public marketing homepage — a React replica of the retired Shopify-hosted
// landing page. Shares SiteNav with the merch store; it does not use the
// authenticated app Layout.
export default function ShopLanding() {
  // The tab title stays the static "dub" from index.html on every route.
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="min-h-screen scroll-smooth bg-[#f6f1f1] font-[var(--font-body)] text-[#292237] antialiased">
      <SiteNav theme="light" />
      <main>
        <ShopHero />
        <ShopCommunity />
        <ShopHowItWorks />
        <ShopTestimonials />
        <ShopMerch />
        <ShopTogether />
        <ShopFinalCTA />
      </main>
      <ShopFooter />
    </div>
  )
}
